var name;

/**
 * Get or set the application name
 */
function appName(newName) {
	if (newName) {
		name = newName;
	} else {
		return name;
	}
}

export default appName;
